import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ClientDash from "./pages/ClientDash";

import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import EntryBCT from "./pages/EntryBCT";


const theme = createTheme({
  palette: {

    primary: {
      light: "#516273",
      main: "#516273",
      dark: "#516273"
    },
    background: {
      default: 'D0D4D7',
      paper: '#D0D4D7',
    },
    secondary: {
      main: "#516273"
    },
    stepper: {
      iconColor: 'green' // or logic to change color
  }


  },
  stepper: {
    iconColor: 'green' // or logic to change color
}
});



function App() {

  React.useEffect(() => {
    document.title = "BCT Tow Trip Manager"
 }, []);

  return (
    <ThemeProvider theme={theme}>

      <BrowserRouter>
        <Routes>
        <Route path="/clientdash" element={<ClientDash />} />
          <Route path="/" element={<EntryBCT />} />
        </Routes>
      </BrowserRouter>

    </ThemeProvider>
  );
}


export default App;
